import { useState } from 'react'
import { useProjectStore } from './state/projectStore'
import { ImportWizard } from './ui/ImportWizard'
import { PlacementMode } from './ui/PlacementMode'
import { ProjectList } from './ui/ProjectList'
import './App.css'

function App() {
  const [view, setView] = useState<'home' | 'import' | 'placement'>('home')
  const currentProject = useProjectStore(state => state.id)
  
  return (
    <div className="app">
      {view === 'home' && (
        <ProjectList 
          onNewProject={() => setView('import')}
          onOpenProject={() => setView('placement')}
        />
      )}
      
      {view === 'import' && (
        <ImportWizard 
          onComplete={() => setView('placement')}
          onCancel={() => setView('home')}
        />
      )}
      
      {view === 'placement' && (
        <PlacementMode 
          onExit={() => setView('home')}
        />
      )}
    </div>
  )
}

export default App
